import RegisterCurated from './curated/Register'
import { AccessType } from 'app/auth/accessControlService'

export const RegisterConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: '/register/curated',
      component: RegisterCurated,
      accesses: [AccessType.ANNONYMOUS],
    },
  ],
}
